export const EnableServiceFormDataConfig: any = {
  PROVIDER: [
    {
      key: 'workflowCode',
      label: 'Service Name',
      defaultValue: '',
      type: 'dropdown',
      size: 6,
      values: [],
      rules: {
        required: {
          value: true,
          message: 'Please select a service'
        }
      },
      labelStyleType: 'InputLabel'
    },
    {
      key: 'subscriptionLimit',
      label: 'Subscribed Limit',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'subscriptionThreshold',
      label: 'Notification Threshold',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'interestedParties',
      label: 'Interested Parties',
      defaultValue: '',
      type: 'text',
      size: 6,
      required: false
    },
    {
      key: 'connectionNote',
      label: 'Connection Notes',
      defaultValue: '',
      type: 'textArea',
      size: 6,
      required: false,
      labelStyleType: 'textAreaLabel'
    }
  ],
  CUSTOMER: [
    {
      key: 'workflowCode',
      label: 'Service Name',
      defaultValue: '',
      type: 'dropdown',
      size: 6,
      values: [],
      rules: {
        required: {
          value: true,
          message: 'Please select a service'
        }
      },
      labelStyleType: 'InputLabel'
    }
  ],
  AGGREGATOR: [
    {
      key: 'workflowCode',
      label: 'Service Name',
      defaultValue: '',
      type: 'dropdown',
      size: 6,
      values: [],
      rules: {
        required: {
          value: true,
          message: 'Please select a service'
        }
      },
      labelStyleType: 'InputLabel'
    },
    {
      key: 'subscriptionLimit',
      label: 'Subscribed Limit',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'subscriptionThreshold',
      label: 'Notification Threshold',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'interestedParties',
      label: 'Interested Parties',
      defaultValue: '',
      type: 'text',
      size: 6,
      required: false
    }
  ],
  CUSTOMER_AGGREGATOR: [
    {
      key: 'workflowCode',
      label: 'Service Name',
      defaultValue: '',
      type: 'dropdown',
      size: 6,
      values: [],
      rules: {
        required: {
          value: true,
          message: 'Please select a service'
        }
      },
      labelStyleType: 'InputLabel'
    },
    {
      key: 'subscriptionLimit',
      label: 'Subscribed Limit',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'subscriptionThreshold',
      label: 'Notification Threshold',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'interestedParties',
      label: 'Interested Parties',
      defaultValue: '',
      type: 'text',
      size: 6,
      required: false
    }
  ]
};

export const EditEnableServiceFormDataConfig: any = {
  PROVIDER: [
    {
      key: 'workflowCode',
      label: 'Service Name',
      defaultValue: '',
      type: 'text',
      size: 6,
      values: [],
      disbaled: true,
      rules: {
        required: {
          value: true,
          message: 'Please select a service'
        }
      },
      labelStyleType: 'InputLabel'
    },
    {
      key: 'subscriptionLimit',
      label: 'Subscribed Limit',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'subscriptionThreshold',
      label: 'Notification Threshold',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'interestedParties',
      label: 'Interested Parties',
      defaultValue: '',
      type: 'text',
      size: 6,
      required: false
    },
    {
      key: 'connectionNote',
      label: 'Connection Notes',
      defaultValue: '',
      type: 'textArea',
      size: 6,
      required: false,
      labelStyleType: 'textAreaLabel'
    }
  ],
  CUSTOMER: [
    {
      key: 'workflowCode',
      label: 'Service Name',
      defaultValue: '',
      type: 'text',
      size: 6,
      disbaled: true,
      values: [],
      rules: {
        required: {
          value: true,
          message: 'Please select a service'
        }
      },
      labelStyleType: 'InputLabel'
    }
  ],
  AGGREGATOR: [
    {
      key: 'workflowCode',
      label: 'Service Name',
      defaultValue: '',
      type: 'text',
      disbaled: true,
      size: 6,
      values: [],
      rules: {
        required: {
          value: true,
          message: 'Please select a service'
        }
      },
      labelStyleType: 'InputLabel'
    },
    {
      key: 'subscriptionLimit',
      label: 'Subscribed Limit',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'subscriptionThreshold',
      label: 'Notification Threshold',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'interestedParties',
      label: 'Interested Parties',
      defaultValue: '',
      type: 'text',
      size: 6,
      required: false
    }
  ],
  CUSTOMER_AGGREGATOR: [
    {
      key: 'workflowCode',
      label: 'Service Name',
      defaultValue: '',
      type: 'text',
      size: 6,
      disbaled: true,
      values: [],
      rules: {
        required: {
          value: true,
          message: 'Please select a service'
        }
      },
      labelStyleType: 'InputLabel'
    },
    {
      key: 'subscriptionLimit',
      label: 'Subscribed Limit',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'subscriptionThreshold',
      label: 'Notification Threshold',
      defaultValue: '',
      type: 'number',
      size: 6,
      required: false
    },
    {
      key: 'interestedParties',
      label: 'Interested Parties',
      defaultValue: '',
      type: 'text',
      size: 6,
      required: false
    }
  ]
};

export default EnableServiceFormDataConfig;
